<template>
    <auth-box class="max-w-[480px]"
        :logo="false">
        <div class="flex flex-col justify-center gap-2 py-10 text-center">
            <div class="flex justify-center">
                <vx-logo-loading></vx-logo-loading>
            </div>
            <div class="text-xl font-bold">
                Redirecting...
            </div>
            <div class="text-slate-500 text-sm">
                This will redirect back to <br />Voxie shortly.
            </div>
        </div>
    </auth-box>
</template>
<script setup>
import { onMounted } from 'vue';
import AuthBox from '../../AuthBox.vue';
import { VxLogoLoading } from '@voxie/frontend-components';

const props = defineProps({
    link: String,
});

onMounted(() => {
    window.location.assign(props.link);
})
</script>
